'use client'

import { Carousel } from 'fukku/Carousel/components/Carousel'
import { CarouselVariants } from 'fukku/Carousel/types'
import { inspModule } from 'inspirationals/constants/datatestIds'
import { useInspirationalProductCardSettings } from 'inspirationals/hooks/useInspirationalProductCardSettings'
import { ModuleTag } from 'inspirationals/types/modules'
import { ProductCardConsumerLayoutProvider } from 'product-card/context/ProductCardConsumerLayoutContext'
import { ProductCardImagesSizesProvider } from 'product-card/context/ProductCardImagesSizesContext'
import type { ImagesSizesLayout } from 'product-card/context/ProductCardImagesSizesContext/ProductCardImagesSizesContext'
import type { ReactNode } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

const MODULES_WITH_SLIDESHOW = [ModuleTag.M4]
const MODULES_WITH_CAROUSEL = [ModuleTag.M3, ModuleTag.M4]

export function ModuleLayout({
	className,
	children,
	defaultImageSizes,
	moduleTag,
}: {
	readonly className: string
	readonly children: ReactNode
	readonly moduleTag: ModuleTag
	readonly defaultImageSizes: ImagesSizesLayout
}) {
	const { isLessThanLarge } = useResponsive()
	const productCardSettings = useInspirationalProductCardSettings({
		withSlideshow: MODULES_WITH_SLIDESHOW.includes(moduleTag),
	})

	const hasCarousel = MODULES_WITH_CAROUSEL.includes(moduleTag)

	return (
		<ProductCardConsumerLayoutProvider settings={productCardSettings}>
			<ProductCardImagesSizesProvider defaultImageSizes={defaultImageSizes}>
				{hasCarousel && isLessThanLarge ? (
					<Carousel
						variant={CarouselVariants.VARIANT2}
						dataTestId={inspModule(moduleTag)}
					>
						{children}
					</Carousel>
				) : (
					<section className={className} data-testid={inspModule(moduleTag)}>
						{children}
					</section>
				)}
			</ProductCardImagesSizesProvider>
		</ProductCardConsumerLayoutProvider>
	)
}
